import React, { useContext, useEffect, useRef, useState } from 'react';
import "./SmsVerification.scss";
import { Button, Col, Row } from 'react-bootstrap';
import { InputOtp } from 'primereact/inputotp';
import { MainApi } from "../../../../../services/authentication/api";
import { Configuration } from '../../../../../services/authentication/configuration';
import { Toast } from "primereact/toast";
import { t, use } from 'i18next';
import { set } from 'lodash';
import AuthContext from '../../../context';


const SmsVerificationResetPassword = (props) => { //  email, smsVerified 
    const toast = useRef(null);
    const mainApi = new MainApi(new Configuration({ basePath: process.env.REACT_APP_AUTHENTICATION_API_BASE_PATH }));
    const [token, setTokens] = useState('');
    const [timer, setTimer] = useState(180);
    const [isTokenValid, setIsTokenValid] = useState(true);
    const contextVal = useContext(AuthContext);

    const customInput = ({ events, props }) => (
        <input
            {...events}
            {...props}
            type="text"
            className={`custom-otp-input ${!isTokenValid ? 'invalid' : ''}`}
        />
    );

    useEffect(() => {
        const countdown = setInterval(() => {
            setTimer(prevTimer => (prevTimer > 0 ? prevTimer - 1 : 0));
        }, 1000);
        return () => clearInterval(countdown);
    }, []);

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    }

    const clickVerify = () => {
        confirmVerification();
        // if (token === '123456') {
        //     console.log('Token is valid');
        //     setIsTokenValid(true);

        // } else {
        //     console.log('Token is invalid');
        //     setIsTokenValid(false);
        //     toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Girdiğiniz kod hatalı. Lütfen tekrar deneyin.' });

        // }
    }

    const clickResendSMS = () => {
        console.log('clickResendSMS');
        setTimer(180); // Reset the timer when resend is clicked
        sendVerificationSMS();
    }

    const handleTokenChange = (e) => {
        setTokens(e.value);
        setIsTokenValid(true); // Reset the validity status on input change
    }

    const beginLogin = () => {
        try {
            contextVal.setAuthState({
                ...contextVal?.authState,
                loginView: true,
                verificationView: false,
                passwordResetView: false,
            });

        } catch (error) {
            // console.log("verificationHandle: " + error);
        }
    };

    //#region API Calls

    const sendVerificationSMS = async () => {
        try {
            const response = await mainApi.apiMainSendResetPasswordSmsGet(props.email).then((res) => {
                console.log(res);
                toast.current.show({ severity: 'success', summary: 'Başarılı', detail: 'SMS başarıyla gönderildi.' });
            })

        } catch (error) {
            console.error(error);
            toast.current.show({ severity: 'error', summary: 'Hata', detail: 'SMS gönderilirken bir hata oluştu. Lütfen tekrar deneyin.' });
        }
    }

    const confirmVerification = async () => {
        try {
            const response = await mainApi.apiMainConfirmResetPasswordSmsGet(token, props.email).then((res) => {
                console.log(res);
                
                if (res.data.Status == 'Ok') {
                    toast.current.show({ severity: 'success', summary: 'Başarılı', detail: 'SMS doğrulaması başarıyla gerçekleştirildi.' });
                    setIsTokenValid(true);
                    props.smsVerified({ smsVerified: true, fingerPrint: res.data.Data });
                }
                else if (res.data.Status == 'Error') {
                    if (res.data.Error?.includes("0x5F1C0C")) {
                        toast.current.show({ severity: "error", summary: "SMS doğrulaması başarısız.", detail: " Hesap bulunamadı." });
                    }
                    else if (res.data.Error?.includes("0x80E5AA")) {
                        toast.current.show({ severity: "error", summary: "SMS doğrulaması başarısız.", detail: " Bu hesaba ait verified collectionında kayıt bulunamadı." });
                    }
                    else if (res.data.Error?.includes("0x80E5AB")) {
                        toast.current.show({ severity: "error", summary: "SMS doğrulaması başarısız.", detail: " Doğrulama kodu süresi doldu, yeniden kod gönderiniz." });
                    }
                    else if (res.data.Error?.includes("0x80E6CD")) {
                        toast.current.show({ severity: "error", summary: "SMS doğrulaması başarısız.", detail: " Doğrulama kodu hatalı." });
                    }
                    else {
                        toast.current.show({ severity: 'error', summary: 'Hata', detail: 'SMS doğrulaması başarısız. Lütfen tekrar deneyin. ' + response.data.Error });
                    }
                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Hata', detail: 'SMS doğrulaması başarısız. Lütfen tekrar deneyin. ' + res.data.Error });
                    setIsTokenValid(false);
                    return;
                }

                // toast.current.show({ severity: 'success', summary: 'Başarılı', detail: 'SMS doğrulaması başarıyla gerçekleştirildi.' });
                // setIsTokenValid(true);
                // props.smsVerified({ smsVerified: true, fingerPrint: res.data.Fingerprint });

            })

        } catch (error) {
            console.error(error);
            toast.current.show({ severity: 'error', summary: 'Hata', detail: 'SMS doğrulaması yapılırken bir hata oluştu. Lütfen tekrar deneyin.' });
            setIsTokenValid(false);
            // props.smsVerified(false);
            props.smsVerified(true);
        }
    }

    //#endregion API Calls

    return (
        <div className='sms-verification-reset-component'>
            <Toast ref={toast} position="bottom-right" />

            <Col>
                <Row>
                    <label className='page-title'>SMS Doğrulama</label>
                </Row>
                <Row>
                    <label className='page-description'>Lütfen cep telefonunuza SMS olarak gelen 6 haneli
                        onay kodunu giriniz.</label>
                </Row>
            </Col>

            <Col>
                <InputOtp value={token} length={6} onChange={handleTokenChange} inputTemplate={customInput} />
            </Col>

            <Col>
                <Row className='timer-container justify-content-center'>
                    <span className={`timer ${timer === 0 ? 'expired' : ''}`}>{formatTime(timer)}</span>
                </Row>
            </Col>

            <Col className='m-t-10'>
                <Row style={{ display: "inline" }} className="m-0 ">
                    <Button
                        slot="end"
                        variant="dark"
                        className="custom-button m-t-30 m-b-15"
                        onClick={clickVerify}
                    >
                        DOĞRULA
                    </Button>
                    <Button
                        slot="end"
                        variant="dark"
                        className="button-resend m-t-5 m-b-15"
                        onClick={clickResendSMS}
                        disabled={timer !== 0}
                    >
                        YENİDEN GÖNDER
                    </Button>
                    <label className="color-text-grey roboto-medium-14 m-t-5 p-0" onClick={beginLogin}>
                        Şifrenizi hatırladınız mı? <span className="login-now-text">Giriş yap.</span>{" "}
                    </label>
                </Row>
            </Col>
        </div>
    );
}

export default SmsVerificationResetPassword;
